<template>
  <header class="kb-header" :class="{ 'kb-header--scrolled': scrolled }">
    <div class="container-xl">
      <nav class="kb-nav">
        <!-- Logo -->
        <router-link to="/" class="kb-logo">
          <img src="@/assets/logo.webp" alt="KeBee Industries" />
          <!-- <span class="kb-logo__text">KeBee <span>Industries</span></span> -->
        </router-link>

        <!-- Desktop Nav -->
        <ul class="kb-nav__links">
          <li><router-link to="/" exact-active-class="active">Home</router-link></li>
          <li><router-link to="/products" active-class="active">Products</router-link></li>
          <li><router-link to="/about" active-class="active">About</router-link></li>
          <li><router-link to="/blog" active-class="active">Blog</router-link></li>
          <li class="kb-nav__dropdown">
            <router-link to="/calculator" active-class="active">Calculator <i class="bi bi-chevron-down"></i></router-link>
            <ul class="kb-nav__dropdown-menu">
              <li><router-link to="/calculator/vehicle"><i class="bi bi-truck-front"></i> Vehicle Calculator</router-link></li>
              <li><router-link to="/calculator/warehouse"><i class="bi bi-buildings"></i> Warehouse Calculator</router-link></li>
              <li><router-link to="/calculator/custom"><i class="bi bi-rulers"></i> Custom Size Calculator</router-link></li>
            </ul>
          </li>
        </ul>

        <!-- CTA + Hamburger -->
        <div class="kb-nav__actions">
          <a class="kb-btn-cta" href="https://wa.me/919892310123?text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20products" target="_blank">
            <i class="bi bi-whatsapp me-2"></i>Contact Us
          </a>
          <button class="kb-hamburger" @click="mobileOpen = !mobileOpen" :class="{ open: mobileOpen }" aria-label="Toggle menu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>
    </div>

    <!-- Mobile Menu -->
    <div class="kb-mobile-menu" :class="{ 'kb-mobile-menu--open': mobileOpen }">
      <ul>
        <li><router-link to="/" @click="mobileOpen = false">Home</router-link></li>
        <li><router-link to="/products" @click="mobileOpen = false">Products</router-link></li>
        <li><router-link to="/about" @click="mobileOpen = false">About</router-link></li>
        <li><router-link to="/blog" @click="mobileOpen = false">Blog</router-link></li>
        <li class="kb-mobile-submenu">
          <div class="kb-mobile-submenu-label" @click="toggleCalculatorMenu">Calculator <i class="bi" :class="calculatorMenuOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i></div>
          <ul class="kb-mobile-submenu-items" :class="{ 'open': calculatorMenuOpen }">
            <li><router-link to="/calculator/vehicle" @click="mobileOpen = false"><i class="bi bi-truck-front me-2"></i>Vehicle Calculator</router-link></li>
            <li><router-link to="/calculator/warehouse" @click="mobileOpen = false"><i class="bi bi-buildings me-2"></i>Warehouse Calculator</router-link></li>
            <li><router-link to="/calculator/custom" @click="mobileOpen = false"><i class="bi bi-rulers me-2"></i>Custom Size Calculator</router-link></li>
          </ul>
        </li>
        <li>
          <a href="https://wa.me/919892310123?text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20products" target="_blank" class="kb-mobile-cta">
            <i class="bi bi-whatsapp me-2"></i>Contact Us
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      scrolled: false,
      mobileOpen: false,
      calculatorMenuOpen: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {
    $route() {
      this.mobileOpen = false
    }
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 60
    },
    toggleCalculatorMenu() {
      this.calculatorMenuOpen = !this.calculatorMenuOpen
    },
  },
}
</script>

<style scoped>
.kb-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 18px 0;
  transition: background 0.3s, box-shadow 0.3s, padding 0.3s;
  background: rgba(240,244,248,0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.kb-header--scrolled {
  background: #fff;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 2px 20px rgba(15, 31, 61, 0.12);
  padding: 10px 0;
}

.kb-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

/* Logo */
.kb-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}
.kb-logo img {
  height: 40px;
  width: auto;
  transition: filter 0.3s;
}
/* White logo on dark/transparent header */
.kb-header:not(.kb-header--scrolled) .kb-logo img {
  filter: none;
}
/* Original logo on white scrolled header */
.kb-header--scrolled .kb-logo img {
  filter: none;
}
.kb-logo__text {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  color: #0F1F3D;
}
.kb-header--scrolled .kb-logo__text {
  color: #0F1F3D;
}
.kb-header:not(.kb-header--scrolled) .kb-logo__text {
  color: #fff;
}
.kb-logo__text span {
  color: #F59E0B;
}

/* Desktop Links */
.kb-nav__links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem;
}
.kb-nav__links a {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 0.95rem;
  text-decoration: none;
  color: #374151;
  letter-spacing: 0.02em;
  position: relative;
  padding-bottom: 4px;
  transition: color 0.2s;
}
.kb-header--scrolled .kb-nav__links a {
  color: #374151;
}
.kb-nav__links a::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 100%;
  height: 2px;
  background: #F59E0B;
  transition: right 0.25s;
}
.kb-nav__links a:hover::after,
.kb-nav__links a.active::after {
  right: 0;
}
.kb-nav__links a:hover,
.kb-nav__links a.active {
  color: #F59E0B;
}

/* Dropdown */
.kb-nav__dropdown {
  position: relative;
}
.kb-nav__dropdown > a i {
  font-size: 0.75rem;
  margin-left: 4px;
  transition: transform 0.2s;
}
.kb-nav__dropdown:hover > a i {
  transform: rotate(180deg);
}
.kb-nav__dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 12px;
  list-style: none;
  padding: 8px 0;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 31, 61, 0.15);
  border-radius: 8px;
  min-width: 220px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: opacity 0.25s, transform 0.25s, visibility 0.25s;
}
.kb-nav__dropdown:hover .kb-nav__dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.kb-nav__dropdown-menu li {
  margin: 0;
  padding: 0;
}
.kb-nav__dropdown-menu a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  color: #374151;
  font-size: 0.9rem;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}
.kb-nav__dropdown-menu a::after {
  display: none;
}
.kb-nav__dropdown-menu a:hover {
  background: #FEF3C7;
  color: #F59E0B;
}
.kb-nav__dropdown-menu a i {
  font-size: 1rem;
  width: 18px;
  text-align: center;
}

/* Actions */
.kb-nav__actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.kb-btn-cta {
  display: inline-flex;
  align-items: center;
  background: #F59E0B;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 10px 22px;
  border-radius: 50px;
  text-decoration: none;
  transition: background 0.2s, transform 0.2s;
  white-space: nowrap;
}
.kb-btn-cta:hover {
  background: #D97706;
  transform: translateY(-1px);
}

/* Hamburger */
.kb-hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 26px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.kb-hamburger span {
  display: block;
  height: 2px;
  background: #0F1F3D;
  border-radius: 2px;
  transition: all 0.3s;
}
.kb-header--scrolled .kb-hamburger span {
  background: #0F1F3D;
}
.kb-hamburger.open span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}
.kb-hamburger.open span:nth-child(2) {
  opacity: 0;
}
.kb-hamburger.open span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

/* Mobile Menu */
.kb-mobile-menu {
  display: none;
  max-height: 0;
  overflow: hidden;
  background: #fff;
  transition: max-height 0.35s ease;
}
.kb-mobile-menu--open {
  max-height: 500px;
}
.kb-mobile-menu ul {
  list-style: none;
  margin: 0;
  padding: 1rem 1.5rem 1.5rem;
}
.kb-mobile-menu li {
  border-bottom: 1px solid #f3f4f6;
}
.kb-mobile-menu a {
  display: block;
  padding: 12px 0;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  color: #374151;
  text-decoration: none;
  font-size: 1rem;
}
.kb-mobile-menu a:hover {
  color: #F59E0B;
}
.kb-mobile-cta {
  margin-top: 10px;
  background: #F59E0B !important;
  color: #fff !important;
  padding: 12px 20px !important;
  border-radius: 50px;
  text-align: center;
  font-weight: 600 !important;
}

/* Mobile Submenu */
.kb-mobile-submenu-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  color: #374151;
  font-size: 1rem;
  cursor: pointer;
  user-select: none;
}
.kb-mobile-submenu-label:hover {
  color: #F59E0B;
}
.kb-mobile-submenu-label i {
  font-size: 0.8rem;
  transition: transform 0.3s;
}
.kb-mobile-submenu-items {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease, margin 0.3s ease, opacity 0.3s ease;
  background: transparent;
  border-radius: 6px;
  opacity: 0;
  visibility: hidden;
}
.kb-mobile-submenu-items.open {
  max-height: 200px;
  padding: 8px 0;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  background: #f9fafb;
  opacity: 1;
  visibility: visible;
}
.kb-mobile-submenu-items li {
  border-bottom: none;
}
.kb-mobile-submenu-items a {
  padding: 10px 20px;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
}
.kb-mobile-submenu-items a:hover {
  background: #fff;
  color: #F59E0B;
}

@media (max-width: 768px) {
  .kb-nav__links { display: none; }
  .kb-btn-cta { display: none; }
  .kb-hamburger { display: flex; }
  .kb-mobile-menu { display: block; }
}
</style>
